// Packages
import { useEffect, useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { motion } from "framer-motion";
// Styles
import Styles from "./Styles/QuarterlyCard.module.css";
// Images
import whiteHeart from "../../../../Assets/Icons/heart.png";
import whiteBookmark from "../../../../Assets/Icons/bookmark.png";
import whiteSendMessage from "../../../../Assets/Icons/send-message.png";
import convertNumbersToPersian from "../../../../Utils/convertNumbersToPersian";

const QuarterlyCard = ({
  index,
  handleAddToCard,
  item,
  handleChangePosts,
  handleSaveQuarterly,
  handleShareQuarterly,
  handleLikePost,
  userBuyedQuarterlysId,
  isLoggedIn,
}) => {
  const { location } = useHistory();

  const { frontCover, title, writer, price, category, likes, _id } = item;

  const buyedThisQuarterly = userBuyedQuarterlysId?.filter(
    (i) => i.quarterlyId === _id
  );

  return (
    <motion.div
      initial={{ x: -1500 }}
      animate={{ x: 0 }}
      transition={{ duration: 1, delay: index * 0.2 }}
      className={Styles.container}
    >
      <img
        src={`${process.env.REACT_APP_PUBLIC_PATH}uploads/images/${frontCover}`}
        alt=""
      />
      <div className={Styles.detailsContainer}>
        <h3 className={Styles.category} onClick={() => handleChangePosts(item)}>
          {category}
        </h3>
        <div className={Styles.infoContainer}>
          <div className={Styles.title}>{title}</div>
          <div className={Styles.writer}>{writer}</div>
        </div>
        <div className={Styles.socialsContainer}>
          <div className={Styles.like}>
            <img onClick={() => handleLikePost(_id)} src={whiteHeart} alt="" />
            <h4>
              {likes.count ? convertNumbersToPersian(String(likes.count)) : "۰"}
            </h4>
          </div>
          <img
            src={whiteBookmark}
            onClick={() => handleSaveQuarterly(_id)}
            alt=""
          />
          <img
            src={whiteSendMessage}
            alt=""
            onClick={() =>
              handleShareQuarterly(
                `https://horme.ir/library/single-quarterly/${_id}`
              )
            }
          />
        </div>
        <div className={Styles.priceContainer}>
          {location.pathname === "/library/my-quarterlys" ? (
            <Link
              style={{ textAlign: "center" }}
              to={`/library/single-quarterlys/${_id}`}
            >
              خواندن
            </Link>
          ) : buyedThisQuarterly?.length !== 0 && isLoggedIn ? (
            <Link
              style={{ textAlign: "center" }}
              to={`/library/single-quarterly/${_id}`}
            >
              خواندن
            </Link>
          ) : (
            <>
              <div className={Styles.price}>{price.toLocaleString()} تومان</div>
              <button
                onClick={() =>
                  handleAddToCard({
                    id: _id,
                    price,
                    text: title,
                    kind: "quarterly",
                  })
                }
              >
                افزودن به سبد خرید
              </button>
              <Link
                style={{ textAlign: "center" }}
                to={`/library/single-quarterly/${_id}`}
              >
                خواندن
              </Link>
            </>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default QuarterlyCard;
